export class NotImplementedError extends Error {
    constructor(message) {
        super(message);
        this.name = 'Not Implemented';
    }
}
//# sourceMappingURL=notImplementedError.js.map